/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckApprovalReadinessResponseDto } from '../../models/check-approval-readiness-response-dto';

export interface DashboardProjectsControllerCheckApprovalReadinessV1$Params {
  id: string;
}

export function dashboardProjectsControllerCheckApprovalReadinessV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerCheckApprovalReadinessV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckApprovalReadinessResponseDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerCheckApprovalReadinessV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckApprovalReadinessResponseDto>;
    })
  );
}

dashboardProjectsControllerCheckApprovalReadinessV1.PATH = '/v1/dashboard/projects/{id}/check-approval-readiness';
